import React, { useEffect, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  TextField,
  Button,
  IconButton,
  Avatar,
  Grid,
  Paper,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { PhotoCamera } from "@mui/icons-material";
import { toast } from "react-toastify";
import apiClient from "../utils/apiClient";
import { getImageFullUrl } from "../utils/common";
import ChangePassword from "../components/ChangePassword";

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

export default function ProfilePage() {
  const [tabValue, setTabValue] = useState(1);
  const [profile, setProfile] = useState({
    fullName: "",
    email: "",
    phone: "",
    profileImage: "",
  });

  const [errors, setErrors] = useState({}); // ✅ Validation errors

  const [preview, setPreview] = useState("");

  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (user) setProfile(user);
  }, [user]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!["image/jpeg", "image/jpg", "image/png", "image/webp"].includes(file.type)) {
      toast.error("Only JPG, PNG, or WEBP images are allowed!");
      return;
    }

    setPreview(URL.createObjectURL(file));
    setProfile({ ...profile, profileImage: file });
  };

  // ✅ Profile Validation
  const validateProfile = () => {
    let tempErrors = {};
    if (!profile.fullName) tempErrors.fullName = "Full name is required";
    if (!profile.email) tempErrors.email = "Email is required";
    if (!profile.phone) tempErrors.phone = "Phone number is required";
    // if (!profile.profileImage) tempErrors.profileImage = "Profile image is required";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

 
  const dispatch = useDispatch()

  // ✅ Handle Profile Update with FormData
const handleProfileUpdate = () => {
  if (!validateProfile()) return;

  const formData = new FormData();
  formData.append("fullName", profile.fullName);
  formData.append("email", profile.email);
  formData.append("phone", profile.phone);

  // append file only if it's a File object (not just a string URL from DB)
  if (profile.profileImage instanceof File) {
    formData.append("profileImage", profile.profileImage);
  }

  apiClient
    .put("/api/admin/edit/"+user?.adminId, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => {
      dispatch({ key: 'user', value: res?.data?.data, type: 'SET_VALUE' })
      toast.success("Profile updated successfully!")})
    .catch((err) => toast.error(err.response?.data?.message || "Server error!"));
};

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid item xs={12} md={8}>
        <Paper sx={{ p: 3, borderRadius: 3 }}>
          <Typography variant="h5" gutterBottom>
            Admin Profile
          </Typography>

          {/* <Tabs
            value={tabValue}
            onChange={(e, newValue) => setTabValue(newValue)}
            sx={{ mb: 2 }}
          >
            <Tab label="Profile Info" />
            <Tab label="Change Password" />
          </Tabs> */}

          {/* ✅ Profile Info */}
          {/* <TabPanel value={tabValue} index={0}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                  sx={{
                    mt: 3,
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  <Box
                    sx={{
                      width: 120,
                      height: 120,
                      borderRadius: "50%",
                      overflow: "hidden",
                      mx: "auto",
                      position: "relative",
                      border: "2px solid #ddd",
                    }}
                  >
                    <Avatar
                      src={preview || getImageFullUrl(profile.profileImage)}
                      sx={{ width: 120, height: 120 }}
                    />
                    <label htmlFor="upload-image">
                      <input
                        accept="image/*"
                        id="upload-image"
                        type="file"
                        style={{ display: "none" }}
                        onChange={handleImageChange}
                      />
                      <IconButton
                        color="primary"
                        component="span"
                        sx={{
                          position: "absolute",
                          bottom: 0,
                          right: 0,
                          bgcolor: "white",
                          boxShadow: 2,
                        }}
                      >
                        <PhotoCamera />
                      </IconButton>
                    </label>
                  </Box>
                  {errors.profileImage && (
                    <Typography color="error" variant="caption">
                      {errors.profileImage}
                    </Typography>
                  )}
                </Box>
              </Box>

              <TextField
                label="Full Name"
                value={profile.fullName}
                onChange={(e) =>
                  setProfile({ ...profile, fullName: e.target.value })
                }
                fullWidth
                error={!!errors.fullName}
                helperText={errors.fullName}
              />

              <TextField
                label="Email"
                value={profile.email}
                onChange={(e) =>
                  setProfile({ ...profile, email: e.target.value })
                }
                fullWidth
                error={!!errors.email}
                helperText={errors.email}
              />

              <TextField
                label="Phone"
                value={profile.phone}
                onChange={(e) =>
                  setProfile({ ...profile, phone: e.target.value })
                }
                fullWidth
                error={!!errors.phone}
                helperText={errors.phone}
              />

              <Button
                variant="contained"
                color="primary"
                onClick={handleProfileUpdate}
              >
                Update Profile
              </Button>
            </Box>
          </TabPanel> */}

          {/* ✅ Change Password */}
          <TabPanel value={tabValue} index={1}>
            <ChangePassword />
          </TabPanel>
        </Paper>
      </Grid>
    </Grid>
  );
}
